import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GenericService } from '../generics/generic.service';
import { PesEndereco } from 'src/app/model/pessoa/pesEndereco';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PesEnderecoService extends GenericService<PesEndereco>{
  
  constructor(http: HttpClient) { 
    super(http);
    super.initResource("pesendereco")
  }
  
  listaEnderecosByPessoaId(pessoaId: number): Observable<PesEndereco[]> {
    const url = `${this.url}/pessoa/${pessoaId}`;
    return this.http.get<PesEndereco[]>(url);
  }
}  
